import { Component, OnInit } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingOrderService } from '../../services/booking-order.service';

@Component({
  selector: 'app-booking-advanced-products',
  templateUrl: './booking-advanced-products.component.html',
  styleUrls: ['./booking-advanced-products.component.css']
})
export class BookingAdvancedProductsComponent implements OnInit {

  constructor(
    protected bookingStepService: BookingStepService,
    protected bookingOrderService: BookingOrderService,
  ) { }

  ngOnInit(): void {
  }

  onBackwardClick(): void {
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    this.bookingStepService.forward();
  }
}
